import { z } from 'zod';
import { ComponentTypeSchema } from './site-report.js';
/**
 * Panel pokrytia (ticket 11, spec „Further Notes"): najtichšie zlyhanie je slug
 * mismatch — premium alebo white-label plugin sa nenamatchuje a „0 zraniteľností"
 * vyzerá ako čistý stav. Preto dashboard prizná, ktoré ŽIVÉ komponenty matching
 * nevie posúdiť:
 *
 *   - `inCatalog: false` — katalóg nemá ŽIADNY `VulnSoftware` záznam pre (type, slug).
 *     Nie „bez nálezu", ale „katalóg o tom nič nevie" (typicky iný slug než vo Wordfence).
 *   - `keyable: false` — verzia sa nedá zakľúčovať (napr. prázdna), takže sa
 *     nedá porovnať so žiadnym rozsahom, aj keby katalóg slug poznal.
 *
 * Komponent v katalógu s kľúčovateľnou verziou a bez nálezu je POKRYTÝ — to je
 * jediný prípad, keď nula naozaj znamená nulu.
 */
export const CoverageItemSchema = z.object({
    siteId: z.string(),
    siteName: z.string(),
    siteHost: z.string(),
    type: ComponentTypeSchema,
    slug: z.string(),
    name: z.string(),
    version: z.string(),
    inCatalog: z.boolean(),
    keyable: z.boolean(),
});
export const CoverageSchema = z.object({
    /** živé komponenty (plugin/theme/core) na živých stránkach */
    total: z.number().int(),
    /** v katalógu a s kľúčovateľnou verziou */
    covered: z.number().int(),
    /** bez záznamu v katalógu (bez ohľadu na verziu) */
    unknown: z.number().int(),
    /** bez kľúčovateľnej verzie (bez ohľadu na katalóg) — počíta sa osobitne */
    unkeyable: z.number().int(),
    /** len nepokryté: `!inCatalog || !keyable` */
    items: z.array(CoverageItemSchema),
});
